<template>
  <v-col
      :class="classFlex"
      :cols="cols"
      :md="md"
      :lg="lg">
    <v-icon v-if="icon">
      {{ icon }}
    </v-icon>
    <label v-if="label" :class="classLabel">
      {{ label + separator }}
    </label>
    <br v-if="multiline">
    <span
        :class="`${classValue} ${icon ?'ml-7' : ''}`">
      {{ displayValue }}
    </span>
  </v-col>
</template>

<script>
  export default {
    props: {
      display: String,
      icon: {
        type: String
      },
      label: {
        type: String
      },
      dateFormat: {
        type: String,
        default: 'DD.MM.YYYY'
      },
      cols: {
        type: [String, Number],
        default: '12'
      },
      md: {
        type: [String, Number],
        default: null
      },
      lg: {
        type: [String, Number],
        default: null
      },
      classFlex: {
        type: String,
        default: 'xs12 py-1 my-1'
      },
      classLabel: {
        type: String,
        default: 'v-label v-label--active font-weight-bold textcolor--text'
      },
      classValue: {
        type: String,
        default: 'v-label v-label--active textcolor--text'
      },
      multiline: {
        type: Boolean,
        default: false
      },
      noData: {
        type: String,
        default: 'Не указано'
      },
      separator: {
        type: String,
        default: ': '
      }
    },
    computed: {
      displayValue () {
        return this.display
          ? this.$moment(this.display).format(this.dateFormat)
          : this.$t(this.noData)
      }
    }
  }
</script>
